var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text-white settings" },
    [
      _c(
        "b-button",
        {
          directives: [
            {
              name: "b-modal",
              rawName: "v-b-modal.settings-modal",
              modifiers: { "settings-modal": true }
            }
          ],
          staticClass: "settings-button"
        },
        [_c("icon", { attrs: { name: "cog" } })],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "settings-modal",
            title: "Настройки",
            "hide-footer": "",
            centered: ""
          }
        },
        [
          _c(
            "div",
            {},
            [
              _c("b-badge", [_vm._v("Общая информация:")]),
              _vm._v(" "),
              _c("div", [
                _vm.userName
                  ? _c("span", [
                      _vm._v("ФИО Сотрудника: " + _vm._s(_vm.userName) + ".")
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", [
                _vm.pageName
                  ? _c("span", [
                      _vm._v("Страница: " + _vm._s(_vm.pageName) + ".")
                    ])
                  : _vm._e()
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm.userRole === _vm.USER_ROLE_CALL_CENTER
            ? _c(
                "b-form-group",
                { staticClass: "mb-0" },
                [
                  _c("b-badge", [_vm._v("Настройки:")]),
                  _vm._v(" "),
                  _c(
                    "b-form-checkbox",
                    {
                      attrs: { name: "callCenterWindowCheckBox", switch: "" },
                      model: {
                        value: _vm.showWindow,
                        callback: function($$v) {
                          _vm.showWindow = $$v
                        },
                        expression: "showWindow"
                      }
                    },
                    [_vm._v("Показывать список заказов")]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ab6d1cf8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab6d1cf8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WorkerAction.vue
// module id = null
// module chunks = 